import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import NativeSelect from '@material-ui/core/NativeSelect';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { DateTimePicker, DatePicker } from '@material-ui/pickers';
import { formatISO, isBefore, isEqual, isValid, parseISO } from 'date-fns';
import { useLazyQuery } from '@apollo/client';

import { formatDate } from '../util/dateHelpers';
import { GET_CARDEXISTS } from '../util/schema';

const useStyles = makeStyles(() => ({
  grid: {
    flexGrow: 1,
    padding: '2%',
  },
  dateTimePicker: {
    minWidth: '330px  !important',
  },
  // TODO: 'formGroup' is referenced but not defined
}));

const AddCardMobile = ({ cardData, setCardData, AEData }) => {
  const classes = useStyles();
  const [currentcardData, setcurrentcardData] = useState({});
  const [date, setDate] = useState(new Date());
  const initialValues = cardData || {
    cardNumber: '',
    // description: '', // TODO: uncomment when enabling description field
    active: false,
    primary: false,
    accessGroups: [],
    singleReaderAccessRights: { engageReaders: [] },
    issueCode: '',
    pin: '',
    useLimit: null,
    vacationStartDate: null,
    vacationEndDate: null,
    freeAntipassback: false,
    antipassbackExempt: false,
    doNotUpdateUseCount: false,
  };

  const defaultEngageCardFormat = 'Standard26Bit';
  const engageCardFormatsThatSupportEngageIssueCode = ['XceedId48X'];
  const supportsEngageIssueCode = (engageCardFormat) => {
    return engageCardFormatsThatSupportEngageIssueCode.includes(engageCardFormat);
  };

  const [state, setState] = React.useState({
    active: initialValues.active || false,
    primary: initialValues.primary || false,
    useAdaTiming: initialValues.useAdaTiming || false,
    cardNumber: initialValues.cardNumber || '',
    description: '',
    engageCardFormat: initialValues.engageCardFormat || defaultEngageCardFormat,
    siteCode: (initialValues.siteCode ? initialValues.siteCode : '0') || '0',
    engageIssueCode: initialValues.engageIssueCode || '',
    cardFunction: initialValues.cardFunction || 'Normal',
    freeAntipassback: initialValues.freeAntipassback || false,
    antipassbackExempt: initialValues.antipassbackExempt || false,
    doNotUpdateUseCount: initialValues.doNotUpdateUseCount || false,
  });
  const [engageCardFormat, setEngageCardFormat] = useState(
    initialValues.engageCardFormat || defaultEngageCardFormat
  );
  const [siteCode, setSiteCode] = useState(
    (initialValues.siteCode ? initialValues.siteCode : '0') || '0'
  );
  const [showSiteCodeValidationWarning, setShowSiteCodeValidationWarning] = useState(false);
  const [engageIssueCode, setEngageIssueCode] = useState(initialValues.engageIssueCode || '');
  const [engageIssueCodeEnabled, setEngageIssueCodeEnabled] = useState(
    supportsEngageIssueCode(initialValues.engageCardFormat)
  );
  const [showEngageIssueCodeValidationWarning, setShowEngageIssueCodeValidationWarning] = useState(
    false
  );
  const [cardFunction, setCardFunction] = useState(initialValues.cardFunction || 'norm');
  const [activedate, setActiveDate] = useState(
    initialValues.activationDate || formatISO(new Date())
  );
  const [activationEnabled, setActivationEnabled] = useState(
    !!initialValues.activationDate || false
  );
  const [deactivedate, setDeactiveDate] = useState(
    initialValues.deactivationDate || formatISO(new Date())
  );
  const [deactivationEnabled, setDeactivationEnabled] = useState(
    !!initialValues.deactivationDate || false
  );
  const [pinEnabled, setpinEnabled] = useState(false);
  const [vacaStrEnabled, setVacaStrEnabled] = useState(!!initialValues.vacationStartDate || false);
  const [vacaStrtDate, setVacaStrDate] = useState(initialValues.vacationStartDate);
  const [vacationEndDateError, setVacationEndDateError] = useState(false);
  const [vacaEndDate, setVacaEndDate] = useState(initialValues.vacationEndDate);
  const [vacaEndEnabled, setVacaEndEnabled] = useState(!!initialValues.vacationEndDate || false);
  const [cardNumber, setCardNumber] = useState(initialValues.cardNumber || '');
  const [description, setDescription] = useState('');
  const [issueCode, setIssueCode] = useState(initialValues.issueCode || '');
  const [pin, setPin] = useState(initialValues.pin || '');
  const [useLimit, setUseLimit] = useState(initialValues.useLimit || '');
  const [useLimitenabled, setUseLimitEnabled] = useState(false);
  const [agchecked, setAGChecked] = useState(initialValues.accessGroups || []);
  const [sdrchecked, setSDRChecked] = useState(initialValues.singleReaderAccessRights || []);
  const [showCardExistsWarning, setShowCardExistsWarning] = useState(false);
  // For Troubleshooting/Debugging Purposes
  // const isEdit = Object.keys(cardData).includes('cardNumber');

  let cardNumberError = '';
  if (!cardNumber) {
    cardNumberError = 'Card Number Required';
  }
  let siteCodeError = '';
  if (showSiteCodeValidationWarning) {
    siteCodeError = 'Site Code must be a whole number greater than 0';
  } else if (!siteCode) {
    siteCodeError = 'Site Code Required';
  }
  let engageIssueCodeError = '';
  if (showEngageIssueCodeValidationWarning) {
    engageIssueCodeError = 'Engage Issue Code must be a whole number greater than 0';
  } else if (engageIssueCodeEnabled && !engageIssueCode) {
    engageIssueCodeError = 'Engage Issue Code Required';
  }

  const [
    checkCardExists,
    { loading: cardExistsLoading, error: cardExistsError, data: cardExistsData },
  ] = useLazyQuery(GET_CARDEXISTS, {
    onCompleted: (data) => {
      setShowCardExistsWarning(data.cardExists);
    },
  });

  const handleState = async (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    // For Troubleshooting/Debugging Purposes
    // console.log('Handle State: ' + event.target.name, event.target.checked);
  };

  const handleSaveCardData = async (event) => {
    const {
      active,
      primary,
      useAdaTiming,
      freeAntipassback,
      antipassbackExempt,
      doNotUpdateUseCount,
    } = state;

    const cardValues = {
      cardNumber,
      // description, // TODO: uncomment when enabling description field
      activationDate: activationPicker || activedate,
      deactivationDate: deactivationPicker || deactivedate,
      engageCardFormat,
      siteCode,
      engageIssueCode,
      cardFunction,
      active,
      primary,
      useAdaTiming,
      accessGroups: agchecked,
      singleReaderAccessRights: sdrchecked,
      issueCode,
      pin,
      useLimit,
      vacationStartDate: vacationEndingDate ? vacationStartingDate : vacaStrtDate,
      vacationEndDate: vacationEndingDate || vacaEndDate,
      freeAntipassback,
      antipassbackExempt,
      doNotUpdateUseCount,
    };
    setcurrentcardData(cardValues);
    AEData(cardValues);
  };

  const updateCardNumber = async (event) => {
    setCardNumber(event.target.value);
    checkCardExists({
      variables: { cardNumber: parseInt(event.target.value) },
    });
  };

  const updateDescription = async (event) => setDescription(event.target.value);
  const updateIssueCode = async (event) => setIssueCode(event.target.value);
  const updatePin = async (event) => setPin(event.target.value);
  const updateUseLimit = async (event) => setUseLimit(event.target.value);
  const [deactivationError, setDeactivationError] = useState(false);
  const updateEngageCardFormat = async (event) => {
    setEngageCardFormat(event.target.value);
    const supportsIssueCode = supportsEngageIssueCode(event.target.value);
    setEngageIssueCodeEnabled(supportsIssueCode);
    if (!supportsIssueCode) {
      setEngageIssueCode('');
    }
  };
  const updateSiteCode = async (event) => {
    const validator = new RegExp(/[^0-9]/g);
    setShowSiteCodeValidationWarning(validator.test(event.target.value));
    const onlyNums = event.target.value.replace(validator, '');
    setSiteCode(onlyNums);
  };
  const updateEngageIssueCode = async (event) => {
    const validator = new RegExp(/[^0-9]/g);
    setShowEngageIssueCodeValidationWarning(validator.test(event.target.value));
    const onlyNums = event.target.value.replace(validator, '');
    setEngageIssueCode(onlyNums);
  };
  const updateCardFunction = async (event) => {
    setCardFunction(event.target.value);
  };

  const generateEngageCardFormatOptions = () => {
    const engageCardFormatOptions = [
      { id: 'Standard26Bit', name: 'Standard 26 bit' },
      { id: 'HidCorporate1000035Bit', name: 'HID Corporate 1000 35 bit' },
      { id: 'Identicard37Bit', name: 'IDenticard 37 bit' },
      { id: 'Hid37Bit', name: 'HID 37 bit' },
      { id: 'MiFareCsn', name: 'MiFare CSN' },
      { id: 'IclassCsn', name: 'iClass CSN' },
      { id: 'Dorado34Bit', name: 'Dorado 34 bit' },
      { id: 'H10313QJoined', name: 'H10313Q (HID) - Joined' },
      { id: 'XceedId40X', name: '40-bit XceedID Cardtrax' },
      { id: 'Csn40Bit', name: '40 bit CSN' },
      { id: 'Rbh50Bit', name: 'RBH50 - 32/16' },
      { id: 'Kastle32Bit', name: 'Kastle 32 bit' },
      { id: 'Csn64Bit', name: '64 bit CSN' },
      { id: 'Awid34Bit', name: 'AWID 34 bit' },
      { id: 'Hid37BitNoSiteCode', name: 'HID 37 bit - No Site Code' },
      { id: 'XceedId48X', name: '48-bit XceedID' },
    ];

    return engageCardFormatOptions.map((option) => (
      <option key={option.id} value={option.id}>
        {option.name}
      </option>
    ));
  };

  const generateFunctionOptions = () => {
    const cardFunctionOptions = [
      { id: 'norm', name: 'Normal' },
      { id: 'toggle', name: 'Toggle' },
      { id: 'freeze', name: 'Freeze' },
      { id: 'lockDown', name: 'Lockdown' },
      { id: 'passThru', name: 'Pass Through' },
      { id: 'oneTm', name: 'One Time Use' },
      { id: 'delAlrm', name: 'Delete With Alarm' },
      { id: 'ctMnAux', name: 'Main and Aux Unlock' },
      { id: 'ctAux', name: 'Aux Unlock' },
      { id: 'ctMnAuxPassThru', name: 'Main and Aux Pass Through' },
      { id: 'ctMnAuxToggle', name: 'Main and Aux Toggle' },
      { id: 'updtFrmSvr', name: 'Update From Server' },
      { id: 'ctAuxToggle', name: 'Aux Toggle' },
      { id: 'updtFrmSvrNrm', name: 'Update From Server' },
    ];

    return cardFunctionOptions.map((option) => (
      <option key={option.id} value={option.id}>
        {option.name}
      </option>
    ));
  };

  let vacationStartingDate;
  let vacationEndingDate;
  let activationPicker;
  let deactivationPicker;

  const showDateIsBeforeEqualDateError = (date1, date2) => {
    // only compare at the minute level, since seconds are not rendered in the interface.
    if (date1 && date2 && isValid(date1) && isValid(date2)) {
      if (isEqual(date1, date2) || isBefore(date1, date2)) {
        return true;
      }
      return false;
    }
    // TODO: Need to return something in this branch
  };

  const showDateIsBeforeDateError = (date1, date2) => {
    // only compare at the minute level, since seconds are not rendered in the interface.
    date1.setSeconds(0);
    date2.setSeconds(0);
    if (date1 && date2 && isValid(date1) && isValid(date2)) {
      if (isEqual(date1, date2)) {
        return false;
      }
      return isBefore(date1, date2);
    }
    // TODO: Need to return something in this branch
  };

  const handleDeactivationDateError = () => {
    // check the error if not the activation date is more than the deactivation date
    return deactivationError
      ? 'Deactivation date must be equal to or after the activation date.'
      : null;
  };

  const updateActivationDate = async (date) => {
    const isoDate = formatISO(date);
    setActiveDate(isoDate);
    if (activationEnabled && deactivationEnabled) {
      setDeactivationError(showDateIsBeforeDateError(parseISO(deactivedate), parseISO(isoDate)));
    }
  };

  const updateDeactivationDate = async (date) => {
    const isoDate = formatISO(date);
    setDeactiveDate(isoDate);
    if (activationEnabled && deactivationEnabled) {
      setDeactivationError(showDateIsBeforeDateError(parseISO(isoDate), parseISO(activedate)));
    }
  };

  const updateActivationEnabled = (event) => {
    setActivationEnabled(event.target.checked);
    setActiveDate(formatISO(new Date()));
    if (event.target.checked && deactivationEnabled) {
      setDeactivationError(showDateIsBeforeDateError(parseISO(deactivedate), parseISO(activedate)));
    } else {
      setDeactivationError(false);
    }
  };

  const updateDeactivationEnabled = (event) => {
    setDeactivationEnabled(event.target.checked);
    setDeactiveDate(formatISO(new Date()));
    if (activationEnabled && event.target.checked) {
      setDeactivationError(showDateIsBeforeDateError(parseISO(deactivedate), parseISO(activedate)));
    } else {
      setDeactivationError(false);
    }
  };

  const updateVacaStrEnabled = (event) => {
    setVacaStrEnabled(event.target.checked);
    setVacaStrDate(formatISO(new Date()));
  };
  const updateVacaEndEnabled = (event) => {
    setVacaEndEnabled(event.target.checked);
    setVacaEndDate(formatISO(new Date()));
  };

  const updateVacationStartDate = async (date) => {
    const isoDate = formatISO(date);
    setVacaStrDate(isoDate);
    // For Troubleshooting/Debugging Purposes
    // console.log(showDateIsBeforeEqualDateError(parseISO(vacaEndDate), parseISO(isoDate)));
  };

  const updateVacationEndDate = async (date) => {
    const isoDate = formatISO(date);
    setVacaEndDate(isoDate);
    // For Troubleshooting/Debugging Purposes
    // console.log(showDateIsBeforeEqualDateError(parseISO(isoDate), parseISO(vacaStrtDate)));
    setVacationEndDateError(
      showDateIsBeforeEqualDateError(parseISO(isoDate), parseISO(vacaStrtDate))
    );
  };

  useEffect(() => {
    vacationEndingDate = vacaEndDate;
    vacationStartingDate = vacaStrtDate;
    activationPicker = activedate;
    deactivationPicker = deactivedate;

    handleSaveCardData();
  }, [vacaEndDate, vacaStrtDate, activedate, deactivedate]);

  const generateRendering = () => {
    return (
      <div
        onClickCapture={handleSaveCardData}
        onMouseLeave={handleSaveCardData}
        onMouseOut={handleSaveCardData}
      >
        <FormControl component="fieldset">
          <Typography variant="h6" style={{ padding: '5px' }} color="primary">
            Add / Edit Card
          </Typography>
          <div className={classes.grid}>
            <Grid container spacing={1} className={classes.formGroup}>
              <Grid item xs="3">
                <FormLabel htmlFor="activeSwitch">Active</FormLabel>
              </Grid>
              <Grid item xs="9" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Switch
                  checked={state.active}
                  onChange={handleState}
                  name="active"
                  id="activeSwitch"
                />
              </Grid>
              <Grid item xs="3">
                <FormLabel htmlFor="primarySwitch">Primary</FormLabel>
              </Grid>
              <Grid item xs="9" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Switch
                  checked={state.primary}
                  onChange={handleState}
                  name="primary"
                  id="primarySwitch"
                />
              </Grid>
              <Grid item xs="4">
                <FormLabel htmlFor="useAdaTimingSwitch">Use ADA Timing</FormLabel>
              </Grid>
              <Grid item xs="8" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Switch
                  checked={state.useAdaTiming}
                  onChange={handleState}
                  name="useAdaTiming"
                  id="useAdaTimingSwitch"
                />
              </Grid>
              <Grid item xs="12">
                <TextField
                  fullWidth
                  placeholder="Cardnumber *"
                  required
                  variant="outlined"
                  value={cardNumber}
                  onChange={updateCardNumber}
                  error={showCardExistsWarning || !cardNumber}
                  helperText={cardNumberError}
                />
              </Grid>
              <Grid item xs="12">
                <TextField
                  fullWidth
                  placeholder="Description"
                  required
                  variant="outlined"
                  value={description}
                  onChange={updateDescription}
                />
              </Grid>
              <Grid item xs="4">
                <FormLabel htmlFor="activationDateDateTimePicker">Activation Date</FormLabel>
              </Grid>
              <Grid item xs="8" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Switch
                  checked={activationEnabled}
                  onChange={updateActivationEnabled}
                  inputProps={{
                    'aria-label': 'Enable Activation Date',
                  }}
                />
              </Grid>
              <Grid item xs="12">
                <div className={classes.dateTimePicker}>
                  <DateTimePicker
                    fullWidth
                    desktopModeMediaQuery="sm"
                    displayStaticWrapperAs="mobile"
                    disabled={!activationEnabled}
                    value={activedate}
                    onChange={updateActivationDate}
                    variant="dialog"
                    DialogProps={{ style: { minWidth: '330px' } }}
                    showTodayButton
                    minDate={undefined}
                    inputVariant={activedate ? 'outlined' : 'filled'}
                    id="activationDateDateTimePicker"
                  />
                </div>
              </Grid>
              <Grid item xs="4">
                <FormLabel htmlFor="deactivationDateDateTimePicker">Deactivation Date</FormLabel>
              </Grid>
              <Grid item xs="8" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Switch
                  checked={deactivationEnabled}
                  onChange={updateDeactivationEnabled}
                  inputProps={{
                    'aria-label': 'Enable Deactivation Date',
                  }}
                />
              </Grid>
              <Grid item xs="12">
                <div className={classes.dateTimePicker}>
                  <DateTimePicker
                    fullWidth
                    desktopModeMediaQuery="sm"
                    displayStaticWrapperAs="mobile"
                    disabled={!deactivationEnabled}
                    value={deactivedate}
                    error={deactivationError}
                    helperText={handleDeactivationDateError()}
                    onChange={updateDeactivationDate}
                    variant="dialog"
                    DialogProps={{ style: { minWidth: '330px' } }}
                    showTodayButton
                    minDate={undefined}
                    defaultValue={formatDate(date, true)}
                    inputVariant={activedate ? 'outlined' : 'filled'}
                    id="deactivationDateDateTimePicker"
                  />
                </div>
              </Grid>
            </Grid>
            <Accordion square>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6" style={{ padding: '5px' }} color="primary">
                  Advanced
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid
                  container
                  spacing={1}
                  className={classes.formGroup}
                  style={{ paddingBottom: '15%' }}
                >
                  <Grid item xs="6">
                    <FormLabel htmlFor="freeAntipassbackSwitch">One Free Antipass Block</FormLabel>
                  </Grid>
                  <Grid item xs="6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Switch
                      checked={state.freeAntipassback}
                      onChange={handleState}
                      name="freeAntipassback"
                      id="freeAntipassbackSwitch"
                    />
                  </Grid>
                  <Grid item xs="6">
                    <FormLabel htmlFor="antipassbackExemptSwitch">AntiPassback Exempt</FormLabel>
                  </Grid>
                  <Grid item xs="6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Switch
                      checked={state.antipassbackExempt}
                      onChange={handleState}
                      name="antipassbackExempt"
                      id="antipassbackExemptSwitch"
                    />
                  </Grid>
                  <Grid item xs="9">
                    <FormLabel htmlFor="doNotUpdateUseCountSwitch">
                      Do not update Use Count on Controller
                    </FormLabel>
                  </Grid>
                  <Grid item xs="3" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Switch
                      checked={state.doNotUpdateUseCount}
                      onChange={handleState}
                      name="doNotUpdateUseCount"
                      id="doNotUpdateUseCountSwitch"
                    />
                  </Grid>
                  <Grid item xs="12">
                    <TextField
                      fullWidth
                      placeholder="Issue Code"
                      variant="outlined"
                      value={issueCode}
                      onChange={updateIssueCode}
                    />
                  </Grid>
                  <Grid item xs="6">
                    <FormLabel htmlFor="pinNumberTextField">Pin Number</FormLabel>
                  </Grid>
                  <Grid item xs="6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Switch
                      checked={pinEnabled}
                      onChange={() => {
                        if (pinEnabled === null) {
                          setpinEnabled(true);
                        } else {
                          setpinEnabled(!pinEnabled);
                        }
                      }}
                      inputProps={{ 'aria-label': 'Enable Pin Number' }}
                    />
                  </Grid>
                  <Grid item xs="12">
                    <TextField
                      fullWidth
                      disabled={!pinEnabled}
                      placeholder="Enter Pin Number"
                      required
                      variant={pinEnabled ? 'outlined' : 'filled'}
                      value={pin}
                      onChange={updatePin}
                      id="pinNumberTextField"
                    />
                  </Grid>
                  <Grid item xs="6">
                    <FormLabel htmlFor="useLimitTextField">Use Limit</FormLabel>
                  </Grid>
                  <Grid item xs="6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Switch
                      checked={useLimitenabled}
                      onChange={() => {
                        if (useLimitenabled === null) {
                          setUseLimitEnabled(true);
                        } else {
                          setUseLimitEnabled(!useLimitenabled);
                        }
                      }}
                      inputProps={{ 'aria-label': 'Enable Use Limit' }}
                    />
                  </Grid>
                  <Grid item xs="12">
                    <TextField
                      fullWidth
                      disabled={!useLimitenabled}
                      placeholder="Enter Use Limit"
                      required
                      variant={useLimitenabled ? 'outlined' : 'filled'}
                      value={useLimit}
                      onChange={updateUseLimit}
                      id="useLimitTextField"
                    />
                  </Grid>
                  <Grid item xs="6">
                    <FormLabel htmlFor="vacationStartDateDatePicker">Vacation Start Date</FormLabel>
                  </Grid>
                  <Grid item xs="6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Switch
                      checked={vacaStrEnabled}
                      onChange={updateVacaStrEnabled}
                      inputProps={{ 'aria-label': 'Enable Vacation Start Date' }}
                    />
                  </Grid>
                  <Grid item xs="12">
                    <div className={classes.dateTimePicker}>
                      <DatePicker
                        fullWidth
                        desktopModeMediaQuery="sm"
                        displayStaticWrapperAs="mobile"
                        disabled={!vacaStrtDate}
                        value={vacaStrtDate || new Date()}
                        onChange={updateVacationStartDate}
                        variant="dialog"
                        DialogProps={{ style: { minWidth: '330px' } }}
                        showTodayButton
                        inputVariant={activedate ? 'outlined' : 'filled'}
                        id="vacationStartDateDatePicker"
                      />
                    </div>
                  </Grid>
                  <Grid item xs="6">
                    <FormLabel htmlFor="vacationEndDateDatePicker">Vacation End Date</FormLabel>
                  </Grid>
                  <Grid item xs="6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Switch
                      checked={vacaEndEnabled}
                      onChange={updateVacaEndEnabled}
                      inputProps={{ 'aria-label': 'Enable Vacation End Date' }}
                    />
                  </Grid>
                  <Grid item xs="12">
                    <div className={classes.dateTimePicker}>
                      <DatePicker
                        fullWidth
                        desktopModeMediaQuery="sm"
                        displayStaticWrapperAs="mobile"
                        disabled={!vacaEndDate}
                        value={vacaEndDate}
                        error={vacationEndDateError}
                        helperText={
                          vacationEndDateError
                            ? 'Vacation end date must be after the vacation start date.'
                            : null
                        }
                        onChange={() => console.log(vacaEndDate)}
                        onAccept={updateVacationEndDate}
                        onClose={handleSaveCardData}
                        variant="dialog"
                        minDate={vacaStrtDate}
                        DialogProps={{ style: { minWidth: '330px' } }}
                        showTodayButton
                        inputVariant={activedate ? 'outlined' : 'filled'}
                        id="vacationEndDateDatePicker"
                      />
                    </div>
                  </Grid>
                  <Grid item xs="4">
                    <FormLabel htmlFor="engageCardFormatNativeSelect" id="engageCardFormatLabel">
                      Engage Card Format
                    </FormLabel>
                  </Grid>
                  <Grid item xs="8">
                    <NativeSelect
                      fullWidth
                      value={engageCardFormat}
                      placeholder="Select Engage Card Format"
                      defaultValue={engageCardFormat}
                      onChange={updateEngageCardFormat}
                      id="engageCardFormatNativeSelect"
                    >
                      {generateEngageCardFormatOptions()}
                    </NativeSelect>
                  </Grid>
                  <Grid item xs="12">
                    <TextField
                      fullWidth
                      placeholder="Site Code *"
                      required
                      variant="outlined"
                      value={siteCode}
                      onChange={updateSiteCode}
                      error={!siteCode}
                      helperText={siteCodeError}
                    />
                  </Grid>
                  <Grid item xs="12">
                    <TextField
                      fullWidth
                      placeholder="Engage Issue Code"
                      variant="outlined"
                      value={engageIssueCode}
                      onChange={updateEngageIssueCode}
                      disabled={!engageIssueCodeEnabled}
                      required={engageIssueCodeEnabled}
                      error={engageIssueCodeEnabled && !engageIssueCode}
                      helperText={engageIssueCodeError}
                    />
                  </Grid>
                  <Grid item xs="4">
                    <FormLabel htmlFor="cardFunctionNativeSelect">Card Function</FormLabel>
                  </Grid>
                  <Grid item xs="8">
                    <NativeSelect
                      fullWidth
                      value={cardFunction}
                      placeholder="Select Card Function"
                      defaultValue={cardFunction}
                      onChange={updateCardFunction}
                      id="cardFunctionNativeSelect"
                    >
                      {generateFunctionOptions()}
                    </NativeSelect>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </div>
        </FormControl>
        <div />
      </div>
    );
  };

  return <>{generateRendering(cardData)}</>;
};

export default AddCardMobile;
